import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
// @ts-expect-error ts(7016) Couldnt find declaration for module. implicit any
import getNativeCurrencySymbol from 'I18n/utils/getNativeCurrencySymbol';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const FormattedPrice = ({
  currencyCode,
  price,
  frequency
}) => {
  const currencyAndAmount = price === 0 ? /*#__PURE__*/_jsxs("span", {
    children: [getNativeCurrencySymbol(currencyCode), " --"]
  }) : /*#__PURE__*/_jsx(FormattedIntlCurrency, {
    value: price,
    currencyCode: currencyCode,
    trailingZeroDisplay: "stripIfInteger"
  });
  if (!frequency || frequency === 'ONE_TIME') {
    return currencyAndAmount;
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: `paymentLinkSelect.recurringBillingTerms.${frequency}`,
    options: {
      price: currencyAndAmount
    }
  });
};
export default FormattedPrice;